import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import DeleteButton from '../atoms/DeleteButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openDelete,
    updateOpenDelete,
    cancelAction,
    deleteAction,
    target,
    deleteMessage
  }) => {
    return (
      <Dialog
        open={openDelete}
        onClose={() => {
          updateOpenDelete(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {deleteMessage ? (
            <DialogContentText id="alert-dialog-description">
              {deleteMessage}
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {target}
              を削除してもよろしいですか？
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <DeleteButton onClickAction={deleteAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
